import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-401da85c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "frisbuy-button-hidden-pages__arrow",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M452.864 149.312a29.12 29.12 0 0 1 41.728.064L826.24 489.664a32 32 0 0 1 0 44.672L494.592 874.624a29.12 29.12 0 0 1-41.728 0 30.592 30.592 0 0 1 0-42.752L764.736 512 452.864 192a30.592 30.592 0 0 1 0-42.688m-256 0a29.12 29.12 0 0 1 41.728.064L570.24 489.664a32 32 0 0 1 0 44.672L238.592 874.624a29.12 29.12 0 0 1-41.728 0 30.592 30.592 0 0 1 0-42.752L508.736 512 196.864 192a30.592 30.592 0 0 1 0-42.688z"
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "frisbuy-button-hidden-pages__dots",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024"
}
const _hoisted_5 = ["fill"]

import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ButtonHiddenPages',
  props: {
    direction: { default: "right" },
    fillColor: { default: "#606266" }
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

function clickHandler() {
  setTimeout(() => {
    isHover.value = false; // NOTE: fix mobile touch
  }, 45); // NOTE: delay only for soft click. Just UX

  emit("click");
}

const isHover = ref<boolean>(false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["frisbuy-button-hidden-pages", [`frisbuy-button-hidden-pages--${props.direction}`]]),
    onClick: clickHandler,
    onMouseover: _cache[0] || (_cache[0] = ($event: any) => (isHover.value = true)),
    onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (isHover.value = false))
  }, [
    (isHover.value)
      ? (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
      : (_openBlock(), _createElementBlock("svg", _hoisted_4, [
          _createElementVNode("path", {
            fill: props.fillColor || 'currentColor',
            d: "M176 416a112 112 0 1 1 0 224 112 112 0 0 1 0-224m336 0a112 112 0 1 1 0 224 112 112 0 0 1 0-224m336 0a112 112 0 1 1 0 224 112 112 0 0 1 0-224"
          }, null, 8, _hoisted_5)
        ]))
  ], 34))
}
}

})